import { MoreFiltersModalFooter } from './MoreFiltersModalFooter';
import {
  NotifyPeopleModalFooter,
  type NotifyPeopleModalFooterProps,
} from './NotifyPeopleModalFooter';

interface ModalFooterProps {
  detailedSearchOpened: boolean;
  footerProps: NotifyPeopleModalFooterProps;
  onCancelFilters: () => void;
  onConfirmSearch: (values: any) => void;
}

export const ModalFooter = ({
  detailedSearchOpened,
  footerProps,
  onCancelFilters,
  onConfirmSearch,
}: ModalFooterProps) =>
  detailedSearchOpened ? (
    <MoreFiltersModalFooter
      onCancel={onCancelFilters}
      onConfirm={onConfirmSearch}
    />
  ) : (
    <NotifyPeopleModalFooter {...footerProps} />
  );
